module.exports = __webpack_public_path__ + "img/pjt01.2364ffeb.png";